import { NavigationProp, ParamListBase } from '@react-navigation/native'

import { GameModeTag, TournamentAccessControl } from '../../models/api-store'
import { membershipType } from '../../screens/join-premium/components/MembershipCard'

export enum HomeRoutes {
  none = 'none',
  home = 'home',
  join = 'join',
  game = 'game',
  userRole = 'userRole',
  createGame = 'createGame',
  createTournament = 'createTournament',
  PracticeGameScreen = 'PracticeGameScreen',
  zogoScreen = 'zogoScreen',
  activeGamesScreen = 'activeGamesScreen',
  openTable = 'openTable',
  JoinOpenTableScreen = 'JoinOpenTableScreen',
  AceptInviteScreen = 'AceptInviteScreen',
  scheduledGameConfirmationScreen = 'scheduledGameConfirmationScreen',
  qRLightBoxScreen = 'qRLightBoxScreen',
  fullScheduleScreen = 'fullScheduleScreen',
  lessonOverviewScreen = 'lessonOverviewScreen',
  joinPremium = 'joinPremium',
  joinPremiumCheckout = 'joinPremiumCheckout',
  membership = 'membership',
  manageMembership = 'manageMembership',
  membershipPlans = 'membershipPlans',
  membershipBillingDetails = 'membershipBillingDetails',
  membershipCancellationSurvey = 'membershipCancellationSurvey',
  myFirstGameScreen = 'myFirstGameScreen',
  myFirstGameWinScreen = 'myFirstGameWinScreen',
  discussionScreen = 'discussionScreen',
  loungeList = 'loungeList',
  loungeJoin = 'loungeJoin',
  loungeLobby = 'loungeLobby',
  loungeSettings = 'loungeSettings'
}

export type ZogoStatus = {
  status: 'COMPLETED' | 'CANCELED' | 'ERROR'
  message: string
}

export type HomeStackParams = {
  home?: ZogoStatus
  join: undefined
  game: undefined
  userRole: undefined
  createGame: undefined
  openTable: undefined
  JoinOpenTableScreen: { gameMode: GameModeTag }
  createTournament: { accessContro?: string; isEdit?: boolean }
  PracticeGameScreen: undefined
  zogoScreen: { moduleId: number; previousRouteName: string }
  activeGamesScreen: { accessControl?: TournamentAccessControl }
  AceptInviteScreen: undefined
  scheduledGameConfirmationScreen: undefined
  qRLightBoxScreen: undefined
  fullScheduleScreen: undefined
  lessonOverviewScreen: { lessonId: string }
  joinPremium: { where?: string }
  joinPremiumCheckout: { membership: membershipType }
  membership: undefined
  manageMembership: undefined
  membershipPlans: undefined
  membershipBillingDetails: undefined
  membershipCancellationSurvey: undefined
  myFirstGameScreen: undefined
  myFirstGameWinScreen: undefined
  discussionScreen: undefined
  loungeList: undefined
  loungeJoin: undefined
  loungeLobby: { loungeId: string }
  loungeSettings: { loungeId: string }
}

export type HomeNavigation = NavigationProp<HomeStackParams & ParamListBase>
